module.exports = __webpack_public_path__ + "static/flags/RS-e940eb548e6205cc906d9aac1a9a5bde.gif";